import type { FaireProductEntity } from "../../entity_types/product";

export const p_3h5gshxutx: FaireProductEntity = {
  token: "p_3h5gshxutx",
  type: "product",
  name: "Diwali Lift-the-Flap",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/d98dda50e4a8c231b85289a279aa2ffb330073b1de9236b2ec45a4a5fb5856ed.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3d81e6dc750099dacadbaf22272dc028e99352f194f1fbeb8b5c287f08dca02d.jpeg",
    "https://cdn.faire.com/fastly/91a11580b08315766e2aecf928f1c6e12f7a0b16ad0dbbdab24eca1288acaa39.jpeg",
    "https://cdn.faire.com/fastly/3225d27eb1203b642d9e47bd6b2fa1812314d6b2f11191f769d285cfdf3d9279.jpeg",
    "https://cdn.faire.com/fastly/50b80056d2db164ec5f096b6835a8bae334d5e9a4a8b4c4188272590a46b307c.jpeg"
  ],
  priceDollars: 4.5,
  description: "Celebrate the Festival of Lights in this joyful lift-the-flap board book adventure all about Diwali! From cleaning the house and lighting diyas to watching fireworks and sharing delicious treats, little ones will love discovering the traditions of this special holiday with every flap they lift. Perfect for curious hands and festive hearts, this sturdy board book introduces young readers to the sights, sounds, and meaning behind one of the brightest celebrations of the year.",
  tags: [],
  msrpDollars: 8.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:07:12.247Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
